export const EVENT_REGISTRATION_EXPERIENCE_LEVELS = [
  'Fresh Graduate without Internship Experience',
  'Fresh Graduate with Internship Experience',
  '0-1 Years of Professional Experience',
  '1-3 Years of Professional Experience',
  '3-5 Years of Professional Experience',
  '5-10 Years of Professional Experience',
] as const

export type EventRegistrationExperienceLevel =
  (typeof EVENT_REGISTRATION_EXPERIENCE_LEVELS)[number]

export const EVENT_REGISTRATION_CANDIDATE_STATUSES = [
  'Masih kuliah, persiapan cari kerja',
  'Sedang Bekerja, aktif mencari peluang baru',
  'Tidak Bekerja, mencari kerja kurang dari 3 bulan',
  'Tidak Bekerja, mencari kerja 3-6 bulan',
  'Tidak Bekerja, mencari kerja 6-12 bulan',
  'Tidak Bekerja, mencari kerja 12-24 bulan',
  'Tidak Bekerja, mencari kerja lebih dari 24 bulan',
] as const

export type EventRegistrationCandidateStatus =
  (typeof EVENT_REGISTRATION_CANDIDATE_STATUSES)[number]
